import { render, staticRenderFns } from "./PollQuestionWrapper.vue?vue&type=template&id=5630beaa&scoped=true"
import script from "./PollQuestionWrapper.vue?vue&type=script&lang=js"
export * from "./PollQuestionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630beaa",
  null
  
)

export default component.exports